import React from 'react'
import {
	CarouselTitle,
	LearnHeroCarousel,
	LearnHeroContainer,
	LearnHeroTitle,
	LearnHeroWrapper
} from './LearnHero.style'
import { Product } from 'services/ContentfulService/models/product'
import { ProductsSection } from 'experiences/learn/products/Section'

interface Props {
	products: Product[]
}

export const LearnHero: React.FC<React.PropsWithChildren<Props>> = ({ products }): JSX.Element => {
	return (
		<LearnHeroWrapper>
			<LearnHeroContainer>
				<LearnHeroTitle>
					Questions?
					<br /> We can help
				</LearnHeroTitle>
				<LearnHeroCarousel>
					<CarouselTitle>What are you interested in?</CarouselTitle>
					<ProductsSection products={products} />
				</LearnHeroCarousel>
			</LearnHeroContainer>
		</LearnHeroWrapper>
	)
}
